import classNames from 'classnames';
import { useHits, useInstantSearch } from 'react-instantsearch';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';

import {
  AnimatedGrid,
  GridOverlayLoadingIndicator,
} from 'components/market/Grid';
import type { CardResultsProps } from 'searchCards/AdvancedCardSearch/types';

import { CommonPlayerPreview } from '../CommonPlayerPreview';
import type { CommonCardsGrid_commonPlayer } from './__generated__/types.graphql';

export const CommonCardsGrid = ({
  onStatsClick,
  sport,
}: CardResultsProps & {
  onStatsClick: (playerSlug: string) => void;
}) => {
  const { up: isTabletOrAbove } = useScreenSize('tablet');

  const { status } = useInstantSearch();
  const { items } = useHits<CommonCardsGrid_commonPlayer>();

  if (sport === Sport.FOOTBALL) return null;

  const loading = status === 'loading' || status === 'stalled';

  return (
    <>
      <AnimatedGrid
        animate={isTabletOrAbove}
        className={classNames({
          twoColumnsOnMobile: !isTabletOrAbove,
        })}
      >
        {items.map((commonPlayer, index) => {
          return (
            <CommonPlayerPreview
              key={commonPlayer.id}
              commonPlayer={commonPlayer}
              onStatsClick={() => onStatsClick(commonPlayer.anyPlayer.slug)}
              showPlayerCostHighlight={index === 0}
            />
          );
        })}
      </AnimatedGrid>
      {!!loading && <GridOverlayLoadingIndicator />}
    </>
  );
};
